var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#DFDFE0;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#025380;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F1A71E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M489.2,94.5H21.9c-9.1,0-14.8,1.4-17.9,4.3c-2.7,3.3-4,8.7-4,16.7v29.9v24.1v172.3V367v28.8   c0,14.3,7.4,21.7,21.9,21.7h467.3c15.2,0,22.8-7.4,22.8-21.7V367v-25.2V169.4v-24.1v-29.9C512,101.3,504.4,94.5,489.2,94.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.9,94.5c-9.1,0-14.8,1.4-17.9,4.3c-2.7,3.3-4,8.7-4,16.7v54h512v-54c0-14.1-7.6-20.9-22.8-20.9H21.9   L21.9,94.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,395.8c0,14.3,7.4,21.7,21.9,21.7h467.3c15.2,0,22.8-7.4,22.8-21.7v-54H0V395.8L0,395.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.6,212.6c0,2.5-0.4,4.5-1.4,5.8l-33.9,59.1l-2.1-72H85l18.2,8.7c5.2,3.3,7.9,7.6,7.9,13l5,76.5h26.5   l63.5-98.2h-32.5C175.6,207.2,176.6,209.9,176.6,212.6L176.6,212.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.8,208.4l2.1-2.9h-33.1c1.2,1.2,1.6,1.7,1.6,2.1c-0.4,1.5-1.2,2.5-1.6,3.7l-48.2,87.9   c-1.2,1.6-2.3,2.9-3.7,4.5h27.3l-1.4-2.9c0-2.5,1.4-7.2,4.3-13.7l5.8-10.8H377c1.2,9.1,1.9,16.7,2.3,22.3l-2.3,5.2h33.9l-5-7.4   L395.8,208.4L395.8,208.4z M375.7,262.4h-20.1l17.2-33.1L375.7,262.4L375.7,262.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292,200.4c-10.5,0-19.4,2.9-27.3,8.7c-8.7,5-13,11.4-13,19.4c0,9.1,3.1,17,9.3,23l18.8,13   c6.8,4.8,10.1,9.1,10.1,13c0,3.7-1.7,7-5,9.5c-3.3,2.5-7,3.7-11.6,3.7c-6.8,0-18.4-4.8-34.5-13.7v18c12.6,7.6,24.8,11.4,36.6,11.4   c11.2,0,20.7-3.1,28.9-10.1c8.7-6.4,13-13.9,13-22.3c0-7-3.1-13.4-10.1-20.1l-18-13c-6-4.8-9.3-9.1-9.3-12.4   c0-7.6,4.5-11.4,13.6-11.4c6.2,0,15.3,3.5,27.5,10.8l3.7-18.8C314.3,203.3,303.6,200.4,292,200.4L292,200.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220,303.6c-0.4-4.1-1.2-7.8-1.6-11.6l24.6-79.4l5.8-7.2h-35.4c0.4,1.7,0.8,4.1,1.2,5.8c0,1.7,0,3.9-0.4,5.8   l-24.6,78.6l-5,7.9H220L220,303.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.1b0af760f4e461521302e7633af7d047.svg";
export { ForwardRef as ReactComponent };